import HttpClient from "../../utils/http";
import {
  organizationsBaseURL,
  organizationDetails,
  organizationModulesCatalog,
} from "../constants/api_endpoints";
import { OrganizationPayload } from "../../views/organizations/model/organization";

export interface OrganizationListFilters {
  page: number;
  size: number;
  keyword?: string;
}

function buildQuery(filters: object): string {
  const params = new URLSearchParams();
  Object.entries(filters as Record<string, unknown>).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, String(value));
    }
  });
  return params.toString();
}

export const getOrganizations = (filters: OrganizationListFilters) =>
  HttpClient.get(`${organizationsBaseURL}?${buildQuery(filters)}`);

export const getOrganization = (orgId: number | string) =>
  HttpClient.get(`${organizationDetails}/${orgId}`);

export const createOrganization = (payload: OrganizationPayload) =>
  HttpClient.post(organizationsBaseURL, payload);

export const updateOrganization = (
  orgId: number | string,
  payload: Partial<OrganizationPayload>
) => HttpClient.patch(`${organizationsBaseURL}/${orgId}`, payload);

export const getModulesCatalog = (orgId?: number | null) =>
  HttpClient.get(
    orgId ? `${organizationModulesCatalog}?orgId=${orgId}` : organizationModulesCatalog
  );
